import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ToplessWaitressesHome from './pages/ToplessWaitressesHome';
import FemaleStrippersPage from './pages/FemaleStrippersPage';
import LingerieModelsPage from './pages/LingerieModelsPage';
import PokerPackagesPage from './pages/PokerPackagesPage';
import CruisePackagesPage from './pages/CruisePackagesPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ToplessWaitressesHome />} />
          <Route path="/female-strippers" element={<FemaleStrippersPage />} />
          <Route path="/lingerie-models" element={<LingerieModelsPage />} />
          <Route path="/poker-packages" element={<PokerPackagesPage />} />
          <Route path="/cruise-packages" element={<CruisePackagesPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
